<template>
  <section class="sign-up section">
    <form @submit.prevent="submit" class="form-container box">
      <p class="has-text-centered has-text-primary is-size-3">Sign up</p>
      <p class="has-text-centered has-text-primary is-size-3">
        {{titles[$route.params.type]}}
      </p>

      <b-field label="Email">
        <b-input type="email" v-model="email" />
      </b-field>

      <b-field label="Password">
        <b-input type="password" v-model="password" password-reveal/>
      </b-field>

      <b-field label="Password repeat" :type="hasError ? 'is-danger' : null"
        :message="hasError ? 'Passwords do not match': null">
        <b-input type="password" v-model="password_confirm" password-reveal/>
      </b-field>
      <div class="button-container">
        <button class="button is-primary" type="submit">
          Sign Up
        </button>
      </div>
    </form>
  </section>
</template>

<script>
import { mapActions } from 'vuex';


export default {
  data() {
    return {
      email: '',
      password: '',
      password_confirm: '',
      dirty: false,
      titles: {
        crew: 'Crew Members',
        owner: 'Owners Brokers Companies',
        on_dock: 'On dock Services',
        diver: 'Divers',
        charterer: 'Charterers',
      },
    };
  },
  computed: {
    hasError() {
      return this.dirty && this.password !== this.password_confirm;
    },
    type() {
      return this.$route.params.type;
    },
  },
  methods: {
    ...mapActions({
      initializeUser: 'auth/initializeUser',
    }),
    validate() {
      return this.password === this.password_confirm;
    },
    async submit() {
      this.dirty = true;
      if (!this.validate()) {
        return;
      }
      try {
        await this.$http.post('/users/', {
          email: this.email,
          password: this.password,
          type: this.type,
        });
      } catch (e) {
        this.$toast.open({
          message: 'Email is already in use',
          type: 'is-danger',
        });
        return;
      }
      const tokens = (await this.$http.post('/users/token/', { email: this.email, password: this.password })).data;
      await this.initializeUser(tokens);
      this.$router.replace({ path: '/' });
    },
  },
  created() {
    if (!this.titles[this.type]) {
      this.$router.replace({ name: 'home' });
    }
  },
};
</script>

<style lang="scss" scoped>
.form-container {
  max-width: 480px;
  min-width: 30vw;
}
.sign-up {
  display: flex;
  justify-content: center;
}
.button-container {
  display: flex;
  justify-content: flex-end;
}
</style>
